import React from 'react';

const SubmitButton = ({ label, onSubmit }) => (
  <button
    className="btn btn-success btn-sm"
    onClick={onSubmit}
    style={{width: '100%', height: '36px', padding: '0'}}>
    {label}
  </button>
);

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/common/form/submitButton.js